import { MEASURE_DISPLAY_NAME, MEASURE_TITLE_SPANISH, MEASURE } from '../shared/MeasuresConstants';
import { COMPOSITE } from '../shared/CommonConstants';

const LENGUAJE_ORAL = 'Lenguaje oral';
const CONCIENCIA_FONOLOGICA = 'Conciencia\n fonológica';
const SONIDOS_DE_LETRAS = 'Sonidos de letras';
const FLUIDEZ_EN_LOS_SONIDOS_DE_LAS_LETRAS = 'Fluidez en los sonidos de las letras';

export const ESPANOL_MEASURES = [MEASURE.TRC, MEASURE.OL, MEASURE.VOCABO, MEASURE.SPELLING];

export const LECTURA_ZOG_MEASURES = [
    MEASURE.FNL, // without optional for Grade 2
    MEASURE.FSS,
    MEASURE.FSL,
    MEASURE.LSS,
    MEASURE.FEP,
    MEASURE.FLO_PREC,
    MEASURE.FLO,
    MEASURE.CLPL, // without optional for Grade 1
    MEASURE.OVERALL,
];

export const SUMMARY_MEASURES = [
    MEASURE.OVERALL,
    MEASURE.TRC,
    MEASURE.OL,
    MEASURE.VOCABO,
    MEASURE.SPELLING,
];

export const PM_MEASURES_EXCEPTIONS = [
    MEASURE.VOCABO,
    MEASURE.OL,
    MEASURE.SPELLING,
    MEASURE.FSLI,
    MEASURE.QQ,
    MEASURE.OVERALL,
];

export const LECTURA_PROGRESS_MEASURES = [
    MEASURE.FSL,
    MEASURE.LSS,
    MEASURE.FSS,
    MEASURE.FEP,
    MEASURE.FLO,
    MEASURE.FLO_PREC,
    MEASURE.CLPL,
    MEASURE.TRC,
];

export const LECTURA_MEASURE_TITLE = {
    [MEASURE.FNL]: 'Nombrar letras',
    [MEASURE.QQ]: CONCIENCIA_FONOLOGICA,
    [MEASURE.FSS]: CONCIENCIA_FONOLOGICA,
    [MEASURE.FSLI]: SONIDOS_DE_LETRAS,
    [MEASURE.FSL]: SONIDOS_DE_LETRAS,
    [MEASURE.LSS]: 'Decodificación',
    [MEASURE.FEP]: 'Lectura de palabras',
    [MEASURE.FLO_PREC]: 'Precisión en la\n lectura',
    [MEASURE.FLO]: 'Fluidez en la\n lectura',
    FLO_OVERALL: 'Fluidez en la lectura oral',
    [MEASURE.CLPL]: 'Comprensión básica',
};

export const LECTURA_MEASURE_NAME = {
    [MEASURE.FNL]: 'Fluidez en nombrar letras',
    [MEASURE.QQ]: '¿Qué queda?',
    [MEASURE.FSS]: 'Fluidez en la segmentación de sílabas',
    [MEASURE.FSLI]: FLUIDEZ_EN_LOS_SONIDOS_DE_LAS_LETRAS,
    [MEASURE.FSL]: FLUIDEZ_EN_LOS_SONIDOS_DE_LAS_LETRAS,
    [MEASURE.LSS]: 'Fluidez en los sonidos de sílabas',
    [MEASURE.FEP]: 'Fluidez en la lectura de palabras',
    [MEASURE.FLO_PREC]: 'Precisión',
    [MEASURE.FLO]: 'Fluidez',
    [MEASURE.CLPL]: '¿Cuál palabra?',
};

export const PARENT_MEASURES_MAP = {
    FLO_OVERALL: 'FLO-OVERALL',
};

export const PARENT_MEASURES = [PARENT_MEASURES_MAP.FLO_OVERALL];

export const ALL_MEASURES = [
    {
        key: MEASURE.OVERALL,
        name: COMPOSITE,
        title: COMPOSITE,
    },
    {
        key: MEASURE.FNL,
        name: MEASURE.FNL,
        title: LECTURA_MEASURE_TITLE[MEASURE.FNL],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FNL],
    },
    {
        key: MEASURE.QQ,
        name: MEASURE.QQ,
        title: LECTURA_MEASURE_TITLE[MEASURE.QQ],
        displayName: LECTURA_MEASURE_NAME[MEASURE.QQ],
    },
    {
        key: MEASURE.FSS,
        name: MEASURE.FSS,
        title: LECTURA_MEASURE_TITLE[MEASURE.FSS],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FSS],
    },
    {
        key: MEASURE.FSLI,
        name: 'FSL\n Inicio',
        title: LECTURA_MEASURE_TITLE[MEASURE.FSLI],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FSLI],
    },
    {
        key: MEASURE.FSL,
        name: MEASURE.FSL,
        title: LECTURA_MEASURE_TITLE[MEASURE.FSL],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FSL],
    },
    {
        key: MEASURE.LSS,
        name: MEASURE.LSS,
        title: LECTURA_MEASURE_TITLE[MEASURE.LSS],
        displayName: LECTURA_MEASURE_NAME[MEASURE.LSS],
    },
    {
        key: MEASURE.FEP,
        name: MEASURE.FEP,
        title: LECTURA_MEASURE_TITLE[MEASURE.FEP],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FEP],
    },
    {
        key: MEASURE.FLO_PREC,
        name: 'FLO-Prec',
        title: LECTURA_MEASURE_TITLE[MEASURE.FLO_PREC],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FLO_PREC],
    },
    {
        key: MEASURE.FLO,
        name: MEASURE.FLO,
        title: LECTURA_MEASURE_TITLE[MEASURE.FLO],
        displayName: LECTURA_MEASURE_NAME[MEASURE.FLO],
    },
    {
        key: PARENT_MEASURES_MAP.FLO_OVERALL,
        name: MEASURE.FLO,
        title: LECTURA_MEASURE_TITLE.FLO_OVERALL,
        displayName: LECTURA_MEASURE_TITLE.FLO_OVERALL,
    },
    {
        key: MEASURE.CLPL,
        name: 'CP',
        title: LECTURA_MEASURE_TITLE[MEASURE.CLPL],
        displayName: LECTURA_MEASURE_NAME[MEASURE.CLPL],
    },
    {
        key: MEASURE.TRC,
        name: MEASURE.TRC,
        title: MEASURE_TITLE_SPANISH[MEASURE.TRC],
        displayName: 'Text Reading and Comprehension',
    },
    {
        key: MEASURE.OL,
        name: MEASURE.OL,
        title: LENGUAJE_ORAL,
        displayName: LENGUAJE_ORAL,
    },
    {
        key: MEASURE.VOCABO,
        name: MEASURE_DISPLAY_NAME[MEASURE.VOCABO],
        title: MEASURE_TITLE_SPANISH[MEASURE.VOCABO],
        displayName: MEASURE_TITLE_SPANISH[MEASURE.VOCABO],
    },
    {
        key: MEASURE.SPELLING,
        name: 'SPELL',
        title: MEASURE_TITLE_SPANISH[MEASURE.SPELLING],
        displayName: MEASURE_TITLE_SPANISH[MEASURE.SPELLING],
    },
];

export const MEASURES = ALL_MEASURES.filter(measure => !PARENT_MEASURES.includes(measure.key));

export const ESPANOL_AVAILABLE_MEASURES = [
    { key: MEASURE.OVERALL, title: 'Lectura' },
    { key: MEASURE.TRC, title: 'TRC Español' },
    { key: MEASURE.OL, title: MEASURE_TITLE_SPANISH[MEASURE.OL] },
    { key: MEASURE.VOCABO, title: MEASURE_TITLE_SPANISH[MEASURE.VOCABO] },
    { key: MEASURE.SPELLING, title: MEASURE_TITLE_SPANISH[MEASURE.SPELLING] },
];

export const MEASURES_KEYS = ALL_MEASURES.map(measure => measure.key);

export const MEASURES_WITH_PERCENTAGE = [MEASURE.FLO_PREC];

export const AVAILABLE_TITLE_MEASURE = [MEASURE.FLO_PREC, MEASURE.FLO];

export const FR_LECTURA_VIEW_MEASURES = [
    MEASURE.OVERALL,
    MEASURE.FSL,
    MEASURE.LSS,
    MEASURE.FSS,
    MEASURE.FEP,
    MEASURE.FLO,
    MEASURE.CLPL,
];

export const HOME_CONNECT_MEASURE_TITLES = {
    [MEASURE.OVERALL]: 'Lectura',
    [MEASURE.TRC]: 'TRC Español',
    [MEASURE.OL]: MEASURE_TITLE_SPANISH[MEASURE.OL],
    [MEASURE.VOCABO]: MEASURE_TITLE_SPANISH[MEASURE.VOCABO],
    [MEASURE.SPELLING]: MEASURE_TITLE_SPANISH[MEASURE.SPELLING],
};

export const MEASURES_WITHOUT_GOAL = [MEASURE.QQ];
